{
  "authLayout": {
    "link": "利用規約",
    "link2": "プライバシーポリシー",
    "link3": "運営会社"
  },
  "forgotPasswordView": {
    "enqueueSnackbar": "認証コードをメールに送信しました",
    "text": "エラーが発生しました",
    "enqueueSnackbar2": "パスワードを再設定しました",
    "text2": "パスワードをお忘れの方",
    "text3": "{{serviceName}}に登録されているメールアドレスを入力して、パスワードを再設定してください。",
    "text4": "メールに送信された認証コードと、新しいパスワードを入力してください。",
    "label": "メールアドレス",
    "placeholder": "メールアドレスを入力",
    "button": "リクエストを送信",
    "label2": "認証コード",
    "placeholder2": "認証コードを入力",
    "label3": "新しいパスワード",
    "placeholder3": "新しいパスワードを入力",
    "button2": "パスワードを再設定",
    "link": "ログインはこちらから"
  },
  "loginView": {
    "text": "にログインする",
    "text2": "Rabbit Live にログインする",
    "text3": "JIZAIPADにログインする",
    "getErrorMessage": "エラーが発生しました",
    "getErrorMessage2": "認証コードが正しくありません",
    "getErrorMessage3": "パスワードの設定に失敗しました",
    "label": "メールアドレス",
    "placeholder": "メールアドレスを入力",
    "label2": "パスワード",
    "placeholder2": "パスワードを入力",
    "link": "パスワードをお忘れの方",
    "button": "ログイン",
    "text4": "または",
    "button2": "外部アカウント（SSO）でログイン",
    "text5": "認証コードを入力してください",
    "label3": "認証コード",
    "placeholder3": "認証コードを入力",
    "button3": "認証する"
  },
  "newPasswordRegistrationForm": {
    "text": "姓を入力してください",
    "text2": "姓は50文字以下で入力してください",
    "text3": "名を入力してください",
    "text4": "名は50文字以下で入力してください",
    "text5": "セイを入力してください",
    "text6": "姓(カナ)にはカタカナのみ入力してください",
    "text7": "姓(カナ)は50文字以下で入力してください",
    "text8": "メイを入力してください",
    "text9": "名(カナ)にはカタカナのみ入力してください",
    "text10": "名(カナ)は50文字以下で入力してください",
    "text11": "パスワードを入力してください",
    "text12": "パスワード確認を入力してください",
    "text13": "パスワードが一致しません",
    "text14": "アカウント情報と新しいパスワードを設定してください",
    "label": "姓",
    "placeholder": "姓を入力",
    "label2": "名",
    "placeholder2": "名を入力",
    "label3": "セイ",
    "placeholder3": "セイを入力",
    "label4": "メイ",
    "placeholder4": "メイを入力",
    "label5": "パスワード",
    "placeholder5": "パスワードを入力",
    "label6": "パスワード確認",
    "placeholder6": "パスワードを再入力",
    "ariaLabel": "利用規約に同意する",
    "link": "利用規約",
    "text15": "および",
    "link2": "プライバシーポリシー",
    "text16": "に同意します"
  },
  "samlLoginFooter": {
    "link": "利用規約",
    "link2": "プライバシーポリシー",
    "link3": "運営会社"
  },
  "samlLoginForm": {
    "required": "テナント ID を入力してください",
    "matches": "英数字とハイフン/アンダースコアのみ使用できます",
    "message": "通信エラーが発生しました。時間をおいて再度お試しください",
    "text": "サーバーで問題が発生しました。時間をおいて再度お試しください",
    "text2": "外部アカウントでのログインはご利用いただけません",
    "text3": "お使いのテナントではSSOが無効になっています。",
    "text4": "SSOは契約テナント向けのオプション機能です。",
    "label": "テナント ID",
    "text5": "外部アカウント（SSO）でログイン",
    "text6": "SSOは契約テナント向けのオプション機能です",
    "link": "通常ログインに戻る"
  },
  "samlLoginTypography": {
    "text": "外部アカウント（SSO）でログイン"
  },
  "useNewPasswordRegistration": {
    "call": "パスワードは変更されました。新しいパスワードで再度ログインしてください。",
    "error": "パスワードの変更には成功しましたが、ユーザー情報の取得に失敗しました。新しいパスワードでログインしてください。"
  },
  "ipNotAllowedView": {
    "title": "このネットワークからはアクセスできません。所属組織の管理者にお問い合わせください。",
    "clientIp": "アクセス元 IP アドレス:",
    "reload": "再読み込み"
  }
}
